<template>
  <ListView
    :items="licenses"
    :selected-item-id="selectedId"
    @select="id => $emit('select', id)"
    @highlight="id => $emit('highlight', id)"
    @unhighlight="id => $emit('unhighlight', id)"
    v-bind="$attrs"
    >
    <template #item="{item}">
      <LicenseItemView :license="item"/>
    </template>
  </ListView>
</template>

<script>
import LicenseItemView from "@/components/LicenseItemView";
import ListView from "@/components/common/ListView.vue";
export default {
  components: {ListView, LicenseItemView},
  emits: ['select', 'highlight', 'unhighlight'],
  props: {
    licenses: Array,
    selectedId: String
  },
  methods: {
    selectLicense(id) {
      this.$emit('select', id);
    }
  }
}
</script>
